import { createListLoadingReducer } from './utils';

export default createListLoadingReducer('SERVICE_GROUPS');
